import { render, staticRenderFns } from "./CFTasksList.vue?vue&type=template&id=237a077a&scoped=true"
import script from "./CFTasksList.vue?vue&type=script&lang=js"
export * from "./CFTasksList.vue?vue&type=script&lang=js"
import style0 from "./CFTasksList.vue?vue&type=style&index=0&id=237a077a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a077a",
  null
  
)

export default component.exports